const figures = [
  { value: '6 mo', label: 'to integrate one fleet' },
  { value: '2×', label: 'the work for the second' },
  { value: '1', label: 'interface after that' },
];

export function Problem() {
  return (
    <section className="sec" id="problem">
      <div className="sec__label">Where it breaks</div>
      <h2 className="statement reveal">Good robots.<br /><span className="hl">Broken handoffs.</span></h2>

      <p className="sec__sub reveal">
        Every fleet arrives with its own controller and its own map, and no two of them agree
        on who has right of way. That makes the second vendor an integration project rather than
        a vehicle purchase.
      </p>

      <div className="metric-line reveal" aria-label="Integration problem in three figures">
        {figures.map((figure) => (
          <div key={figure.value}><b>{figure.value}</b><span>{figure.label}</span></div>
        ))}
      </div>
    </section>
  );
}
